import BaseUtil from "../../util/BaseUtil";

const type = `@@ActionType/UPDATE@${__filename}`;

const unitFilterTypeMap = {
    OUT: "轮转科室",
    IN: "所在科室",
}

const initState = {
    unitFilterType: "OUT", // 科室筛选条件
    selectedUnitIds: null,  // 选中的科室
    unitsMap: null, // 科室map
    users: null, // 数据
    keyword: "", // 搜索关键词
    tableLoading: false, // 数据加载
    pageable: {
        current: 1,
        limit: 30,
    },
    datePicker: {
        beginDate: null, // datepicker开始时间
        endDate: null, // datepicker结束时间
    },
    editData: null, // 点击编辑后的记录

    fileImportVisible: false, // 文件导入modal
    editModalVisible: false, // 添加编辑modal
    commentModalVisible: false, // 评价modal
    editConfirmLoading: false, // 编辑确定loading, modal共用

    isSynchronized: false, // 已经同步了
    synchronizeSubmitted: true, // 提交了申请同步
    synchronizeModalVisible: false, // 同步modal
}

const [viewModel, update, reset] = BaseUtil.getViewModel(initState, type);

export {
    update,
    reset,
    unitFilterTypeMap,
};
export default viewModel;
